import cx from 'classnames'

import { User } from 'lib/_types'
import { PLACEHOLDER_PROFILE_IMAGE } from 'lib/image'

import ImageLoader from 'components/ImageLoader'

import './style.scss'

const Avatar = ({
  user,
  className,
  wrapperClassName,
  showVipCircle,
  showOnlineStatus,
  disableViewportCheck,
  placeholderImage = PLACEHOLDER_PROFILE_IMAGE,
  ...props
}: {
  user: Partial<Omit<User, 'id'>>
  className?: string
  showVipCircle?: boolean
  showOnlineStatus?: boolean
  wrapperClassName?: string
  disableViewportCheck?: boolean
  placeholderImage?: string
}) => {
  return (
    <div className={cx('Avatar__wrapper', wrapperClassName)}>
      <ImageLoader
        url={user?.profile_icon_thumbnail ?? placeholderImage}
        className={cx('Avatar', {
          'Avatar--vip': user?.vip && !user?.hide_vip && showVipCircle,
          [className]: className,
        })}
        alt={`${user?.nickname}のカバー写真`}
        placeholderImage={placeholderImage}
        {...props}
      />

      {user?.online_status !== 'hidden' && showOnlineStatus && (
        <div
          className={cx(
            'Avatar__status',
            `Avatar__status--${user?.online_status}`
          )}
        />
      )}
    </div>
  )
}

export default Avatar
